var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"apiErrorModal",attrs:{"visible":_vm.shown,"centered":"","title":"Wystąpił błąd","ok-only":""},on:{"hidden":_vm.hide}},[_vm._v("\n  Wystąpił błąd: "+_vm._s(_vm.error)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }